export default __webpack_public_path__ + "static/media/ace_of_cups.f0b74443.png";